var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPregnancyConsultations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 160,
    viewBox: "0 0 241 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.366,
    cy: 79.8651,
    rx: 49.3702,
    ry: 49.4667,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.305 137.11L178.593 131.387M162.599 133.676C172.694 133.676 180.878 125.476 180.878 115.361C180.878 105.247 172.694 97.0469 162.599 97.0469C152.504 97.0469 144.32 105.247 144.32 115.361C144.32 125.476 152.504 133.676 162.599 133.676Z",
    stroke: "#D9D8DF",
    strokeWidth: 9.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.03 26.5703H68.0182C65.0785 26.5703 62.6953 29.2311 62.6953 32.5134V107.1C62.6953 110.382 65.0785 113.043 68.0182 113.043H121.03C123.969 113.043 126.353 110.382 126.353 107.1V32.5134C126.353 29.2311 123.969 26.5703 121.03 26.5703Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 1.65333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.09 93.25H76.0383C74.9298 93.25 74.0312 94.1503 74.0312 95.2609C74.0312 96.3715 74.9298 97.2719 76.0383 97.2719H113.09C114.198 97.2719 115.097 96.3715 115.097 95.2609C115.097 94.1503 114.198 93.25 113.09 93.25Z",
    fill: "#D9D8DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.781 85.2109H76.347C75.068 85.2109 74.0312 86.2498 74.0312 87.5312C74.0312 88.8127 75.068 89.8515 76.347 89.8515H112.781C114.06 89.8515 115.097 88.8127 115.097 87.5312C115.097 86.2498 114.06 85.2109 112.781 85.2109Z",
    fill: "#D9D8DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.781 100.68H76.347C75.068 100.68 74.0312 101.719 74.0312 103C74.0312 104.281 75.068 105.32 76.347 105.32H112.781C114.06 105.32 115.097 104.281 115.097 103C115.097 101.719 114.06 100.68 112.781 100.68Z",
    fill: "#D9D8DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6704 34.5484C71.6704 33.3524 70.7027 32.3828 69.509 32.3828C68.3153 32.3828 67.3477 33.3524 67.3477 34.5484C67.3477 35.7444 68.3153 36.714 69.509 36.714C70.7027 36.714 71.6704 35.7444 71.6704 34.5484Z",
    fill: "#D9D8DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8462 34.5484C77.8462 33.3524 76.8785 32.3828 75.6848 32.3828C74.4911 32.3828 73.5234 33.3524 73.5234 34.5484C73.5234 35.7444 74.4911 36.714 75.6848 36.714C76.8785 36.714 77.8462 35.7444 77.8462 34.5484Z",
    fill: "#D9D8DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.022 34.5484C84.022 33.3524 83.0543 32.3828 81.8606 32.3828C80.6669 32.3828 79.6992 33.3524 79.6992 34.5484C79.6992 35.7444 80.6669 36.714 81.8606 36.714C83.0543 36.714 84.022 35.7444 84.022 34.5484Z",
    fill: "#D9D8DF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_961_69740)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_961_69740",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 43,
    width: 34,
    height: 33
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8477 43H110.379V75.5312H77.8477V43Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_961_69740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.457 61.0469C86.457 59.8388 87.4364 58.8594 88.6446 58.8594C89.8527 58.8594 90.832 59.8388 90.832 61.0469",
    stroke: "#006546",
    strokeWidth: 1.62656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3984 61.0469C97.3984 59.8388 98.3778 58.8594 99.5859 58.8594C100.794 58.8594 101.773 59.8388 101.773 61.0469",
    stroke: "#006546",
    strokeWidth: 1.62656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3438 65.4072C91.1047 66.6968 92.5077 67.5625 94.1135 67.5625C95.7193 67.5625 97.1223 66.6968 97.8832 65.4072",
    stroke: "#006546",
    strokeWidth: 1.62656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.426 60.6657C109.426 62.4562 107.992 63.9118 106.209 63.9455C104.768 69.2744 99.8984 73.1953 94.1133 73.1953C88.3282 73.1953 83.4587 69.2744 82.0177 63.9455C80.2348 63.9118 78.8008 62.4562 78.8008 60.6657C78.8008 59.7597 79.168 58.9394 79.7615 58.3453C80.3416 57.7658 81.1371 57.4024 82.0177 57.3859C83.4587 52.057 88.3282 48.1361 94.1133 48.1361C99.8984 48.1361 104.768 52.057 106.209 57.3859C107.09 57.4024 107.885 57.7658 108.465 58.3453C109.059 58.9394 109.426 59.7597 109.426 60.6657Z",
    stroke: "#006546",
    strokeWidth: 1.62656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0399 52.2118C90.0399 54.4636 91.8654 56.2891 94.1172 56.2891C96.369 56.2891 98.1945 54.4636 98.1945 52.2118C98.1945 49.96 96.369 48.1345 94.1172 48.1345H93.4782C91.4149 48.1345 89.7422 46.4618 89.7422 44.3984",
    stroke: "#006546",
    strokeWidth: 1.62656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1133 48.1406H89.0993C87.0359 48.1406 85.3633 46.4679 85.3633 44.4046",
    stroke: "#006546",
    strokeWidth: 1.62656,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_961_69740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5312,
    height: 32.5312,
    fill: "white",
    transform: "translate(77.8477 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPregnancyConsultations);
export default __webpack_public_path__ + "static/media/empty-pregnancy-consultations.264b258cdcd284a3dedbf3a78453ebf5.svg";
export { ForwardRef as ReactComponent };